import type {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {AUTH_LOGIN_ROUTE} from 'routes/constants';
import {useInstantCheckInOffer} from './useInstantCheckInOffer';

function InstantCheckInGate({children}: {children: ReactNode}) {
  const {getFullPath} = usePath();
  const {isDeciding, shouldOffer} = useInstantCheckInOffer();

  if (shouldOffer) {
    return <Navigate to={getFullPath(AUTH_LOGIN_ROUTE)} replace />;
  }

  if (isDeciding) {
    return null;
  }

  return children;
}

export {InstantCheckInGate};
